import { useUserInfo, useUserInfoContext } from '@xolv-mybrightlink/common';
import { useCallback, useState } from 'react';
import { joinCommunity } from '../../../../community/service/CommunitySetupService';

export const useCommunityOptInStatus = () => {
  const userInfo = useUserInfo();
  return userInfo.community_opt_in;
};

export const useOptInCommunity = () => {
  const [, dispatch] = useUserInfoContext();
  const [loading, setLoading] = useState(false);
  const optInCommunity = useCallback(async () => {
    try {
      setLoading(true);
      await joinCommunity();
      dispatch({ type: 'COMMUNITY_OPT_IN' });
    } finally {
      setLoading(false);
    }
  }, [dispatch]);
  return { loading, optInCommunity };
};
